var React = require('react');

function NagrodaIn (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-1{fill:#00deb2;}")),React.createElement("title",{"key":1},"Write\r_message"),React.createElement("g",{"id":"Layer_2","data-name":"Layer 2","key":2},React.createElement("g",{"id":"Layer_1-2","data-name":"Layer 1"},[React.createElement("polygon",{"className":"cls-1","points":"16.79 22.28 1.74 22.28 1.74 3.88 11.42 3.88 11.42 2.14 0 2.14 0 24.02 18.53 24.02 18.53 9.05 16.79 9.05 16.79 22.28","key":0}),React.createElement("polygon",{"className":"cls-1","points":"15.91 2.56 14.66 1.91 5.16 11.41 4.23 16.44 9.25 15.5 20.66 4.09 16.57 0 15.63 0.94 16.57 1.9 16.57 1.9 18.77 4.09 8.6 14.26 5.9 14.76 6.4 12.06 15.91 2.56","key":1})]))]);
}

NagrodaIn.defaultProps = {"viewBox":"0 0 20.66 24.02"};

module.exports = NagrodaIn;

NagrodaIn.default = NagrodaIn;
